import { toast } from 'react-toastify'; 
import axios from 'axios';
import API from '../../config/apiconfig';
import { useDispatch } from 'react-redux';
import { userManagementApiLoader } from '../../action/loaderActions';

export const useSendVerificationInstance = () => {
  const dispatch = useDispatch();
  const resendEmail = ({ email }) => {
      dispatch(userManagementApiLoader({isUsermanagementLoader: true}));
      const data = {
        "email" : email
      };
      axios.post(
          `${API.USER_MANAGEMENT_API_BASE_URL}${API.RESEND_VERFICATION_EMAIL}`,
          data,
          {
              headers: {
                  'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY,
              },
          }
      )
      .then((response) => {
        toast.success(response.data?.message, {
          autoClose: 6000,
        });
        console.log(response.data);
        dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || 'Error logging in!', {
          autoClose: 6000,
        });
        console.error('Error logging in:', error.response || error);
        dispatch(userManagementApiLoader({isUsermanagementLoader: false}));
      });
  };

  return { resendEmail };
};
